import { create } from 'zustand';
import { TVideoResolutionPreset, DEFAULT_VIDEO_RESOLUTION } from '@src/utils/videoConstraints.utils';

interface IMediaSettings {
  audioInputDevices: MediaDeviceInfo[];
  videoInputDevices: MediaDeviceInfo[];
  speakerDevices: MediaDeviceInfo[];
  isVideoAllowed: boolean;
  isAudioAllowed: boolean;
  isOpenMediaPreview: boolean;
  selectedSpeakerDevice: MediaDeviceInfo | null;
  selectedVideoInputDevice: MediaDeviceInfo | null;
  selectedAudioInputDevice: MediaDeviceInfo | null;
  /** Selected video resolution preset for MediaSoup (Meet mode only) */
  selectedVideoResolution: TVideoResolutionPreset;
}

interface IMediaSettingsStore {
  isEnumerateVideoDevices: boolean;
  isEnumerateAudioDevices: boolean;
  mediaSettings: IMediaSettings;
  setMediaSettings: (settings: Partial<IMediaSettings>) => void;
  setIsEnumerateVideoDevices: (isEnumerated: boolean) => void;
  setIsEnumerateAudioDevices: (isEnumerated: boolean) => void;
  /** Update video resolution */
  setVideoResolution: (resolution: TVideoResolutionPreset) => void;
}

export const useMediaSettingsStore = create<IMediaSettingsStore>((set) => ({
  isEnumerateVideoDevices: false,
  isEnumerateAudioDevices: false,
  mediaSettings: {
    audioInputDevices: [],
    videoInputDevices: [],
    speakerDevices: [],
    isVideoAllowed: false,
    isAudioAllowed: false,
    isOpenMediaPreview: false,
    selectedSpeakerDevice: null,
    selectedVideoInputDevice: null,
    selectedAudioInputDevice: null,
    selectedVideoResolution: DEFAULT_VIDEO_RESOLUTION,
  },
  setMediaSettings: (mediaSettings) =>
    set((state) => ({ ...state, mediaSettings: { ...state.mediaSettings, ...mediaSettings } })),
  setIsEnumerateVideoDevices: (isEnumerateVideoDevices) => set((state) => ({ ...state, isEnumerateVideoDevices })),
  setIsEnumerateAudioDevices: (isEnumerateAudioDevices) => set((state) => ({ ...state, isEnumerateAudioDevices })),
  setVideoResolution: (resolution) => {
    set((state) => ({
      ...state,
      mediaSettings: { ...state.mediaSettings, selectedVideoResolution: resolution },
    }));
  },
}));
